var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartoon1 = function SvgCartoon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 37 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1F4970",
    clipPath: "url(#cartoon1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7.875A3.938 3.938 0 1 0 18.5 0a3.938 3.938 0 0 0 0 7.875M31.227 9H5.773a1.898 1.898 0 0 0 0 3.797h7.164c.486 0 1.055.217 1.377 1.055.376.972.191 2.85-.04 4.305l-.304 1.719a.03.03 0 0 1-.009.025l-2.433 13.838a1.93 1.93 0 0 0 1.558 2.232 1.9 1.9 0 0 0 2.21-1.568l1.68-9.618s.54-2.285 1.524-2.285c1 0 1.529 2.285 1.529 2.285l1.68 9.627a1.914 1.914 0 0 0 3.472.775 1.92 1.92 0 0 0 .299-1.45l-2.434-13.839v-.013l-.007-.011-.305-1.72c-.232-1.454-.416-3.332-.04-4.304.32-.836.908-1.055 1.356-1.055h7.177a1.899 1.899 0 0 0 0-3.797z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cartoon1_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h36v36H.5z"
  })))));
};
export default SvgCartoon1;